import { FC, useEffect } from 'react';
import { useLocation } from 'react-router';
import { useBreadcrumbs } from '@connect-x-app/web-state';
import { BreadCrumbType } from '@connect-x-app/web-types';
import { useShallow } from 'zustand/react/shallow';

import { BreadCrumb } from './BreadCrumb';

const breadCrumbRouteNames: BreadCrumbType[] = [{ name: 'smart actions', url: 'smart-actions' }];

export const BreadCrumbs: FC = () => {
  const location = useLocation();

  const { crumbs, init } = useBreadcrumbs(
    useShallow(state => ({
      crumbs: state.parsedCrumbs,
      init: state.init,
    })),
  );

  useEffect(() => {
    const pathNames = location.pathname
      .split('/')
      .filter(x => x)
      .map((pathName, index) => {
        const completeBackwardsConstructedUrl = `/${location.pathname
          .split('/')
          .filter(Boolean)
          .slice(0, index + 1)
          .join('/')}`;
        const breadCrumb = breadCrumbRouteNames.find(route => route.url === pathName);
        return breadCrumb ?? { name: pathName, url: completeBackwardsConstructedUrl };
      });

    init(pathNames);
  }, [location, init]);

  return (
    <nav className="bread-crumb">
      <ul className="nav-bar-ul">
        {crumbs.map((crumb, index, { length }) => {
          const isLast = index === length - 1;
          return <BreadCrumb disabled={isLast} key={crumb.url} name={crumb.name} url={crumb.url} />;
        })}
      </ul>
    </nav>
  );
};
